import React from 'react';
import $decks from 'app/stores/decks/$decks';
import { EmptyState, FlexColumn } from 'core/components';
import getErrorBoundary from 'core/util/getErrorBoundary';
import WidgetFrame from 'app/components/decks/widgets/WidgetFrame';

const ErrorBoundary = getErrorBoundary('WidgetPanel');

function ErrorState({ icon, description, ...widgetProps }) {
  return (
    <WidgetFrame {...widgetProps}>
      <EmptyState icon={icon} description={description} />
    </WidgetFrame>
  );
}

function WidgetPanel(props) {
  const { board, panel, form, config: _config, height = 360, approxWidth = 900, ...widgetProps } = props;
  const config = form ? form.getValues().config : _config;
  const { widgetName } = config;

  if (!widgetName) {
    return <ErrorState description="Please select a widget type." {...widgetProps} />;
  }

  const widgetConfig = $decks.widgets[widgetName];

  if (!widgetConfig) {
    console.warn(`Widget "${widgetName}" not found.`);
    return null;
  }

  const { Component: Widget } = widgetConfig;

  const handleConfigChange = (newConfig) => {
    if (form) {
      form.setValuesDeep({ config: newConfig });
      if (form.onChange) {
        form.onChange({ form, formValues: form.getValues() });
      }
    } else {
      panel.save({ config: newConfig }, { optimistic: true, draft: true });
    }
  };

  return (
    <ErrorBoundary>
      <FlexColumn width="100%" height="100%">
        <Widget
          {...widgetProps}
          height={height}
          approxWidth={approxWidth}
          config={config}
          onConfigChange={handleConfigChange}
          isConfigurePanelOpen={false}
        />
      </FlexColumn>
    </ErrorBoundary>
  );
}

export default WidgetPanel;
